import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import authService from "../../../Services/authService";

export default function OtpVerificationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const phoneNumber = searchParams.get("phone") || "";

  const formattedPhone = phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, "$1 $2 $3");

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [isResendActive, setIsResendActive] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const inputRefs = useRef([]);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState({});

  useEffect(() => {
    if (timer > 0 && !isResendActive) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setIsResendActive(true);
    }
  }, [timer, isResendActive]);

  useEffect(() => {
    if (success.otp) {
      const timer = setTimeout(() => {
        setSuccess({});
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success.otp]);

  const handleChange = (index, value) => {
    if (value && !/^\d+$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text/plain").trim();
    if (/^\d{6}$/.test(pasted)) {
      const digits = pasted.split("");
      setOtp(digits);
      inputRefs.current[5]?.focus();
    }
  };

  const handleResendOtp = async (e) => {
    setTimer(30);
    setIsResendActive(false);
    //console.log("Resending OTP to", phoneNumber);
    try {
      const response = await fetch(authService.getApiUrl() + 'send-otp', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          phone_number: phoneNumber,
        }),
      });
      if (response) {
        //localStorage.setItem("authCompleted", "true");
        //navigate("/");
        //} else {
        setSuccess({ otp: "OTP sent successfully" });
      }
    } catch (err) {
      setErrors({ otp: "Something went wrong. Please try again." });
      //console.error("OTP verification error:", err.message);
    } finally {
      //setIsVerifying(false);
    }
    // You can add resend logic here using `authService`
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpString = otp.join("");
    setIsVerifying(true);
    setErrors({});

    try {
      const response = await authService.Userlogin(phoneNumber, otpString);
      if (response) {
        //localStorage.setItem("authCompleted", "true");
        const pendingItem = JSON.parse(localStorage.getItem('pendingCartItem'));

        if (pendingItem) {
          // Call API to add item to cart
          const token = authService.getCurrentUsertoken();
          fetch(authService.getApiUrl() + "cart", {
            method: "POST",
            body: JSON.stringify({
              user_id: authService.getCurrentuser().id,
              type: pendingItem.type,
              name: pendingItem.name,
              test_id: pendingItem.test_id,
              quantity: 1,
              price: pendingItem.price,
              overall_price: pendingItem.price,
              preparation: "",
              organization_id: 1,
              visit_type: pendingItem.visit_type,
            }),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res) => res.json())
            .then(() => {
              localStorage.removeItem('pendingCartItem');
              // Optionally show toast: "Item added to cart"
              // Redirect back to CategoryPage
              //window.location.href = document.referrer || "/"; // or store and use a better redirect path
              navigate("/");
            })
            .catch((err) => {
              console.error("Error adding pending cart item:", err);
              localStorage.removeItem('pendingCartItem');
            });
        }

        navigate("/");
      } else {
        setErrors({ otp: "Invalid OTP" });
      }
    } catch (err) {
      setErrors({ otp: "Something went wrong. Please try again." });
      console.error("OTP verification error:", err.message);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F7] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-sm border border-[#E0E0E0] overflow-hidden">
            <div className="p-6 border-b border-[#E0E0E0] flex flex-col items-center">
              <div className="mb-4 flex justify-center">
                <img
                  src="/images/pranaam-365-logo.png"
                  alt="Pranaam 365 Logo"
                  className="h-auto w-[140px]"
                />
              </div>
              <h1 className="text-2xl font-semibold text-[#4A4A4A]">Verify OTP</h1>
              <p className="text-sm text-[#4A4A4A]/70 text-center mt-2">
                We've sent a verification code to{" "}
                <span className="font-medium text-[#4A4A4A]">
                  {phoneNumber ? `+91 ${formattedPhone}` : "your phone"}
                </span>
              </p>
            </div>

            <div className="p-6">
              <form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-3 text-center">
                    Enter verification code
                  </label>
                  <div className="flex justify-between gap-2">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        inputMode="numeric"           // Shows numeric keyboard on mobile
                        pattern="[0-9]*"              // Enforces numeric input
                        maxLength={1}
                        className="w-12 h-12 text-center text-lg font-medium border border-[#E0E0E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#951C25]/20 focus:border-[#951C25]"
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={index === 0 ? handlePaste : undefined}
                        autoFocus={index === 0}
                      />
                    ))}

                  </div>
                  {errors.otp && (
                    <p className="text-red-500 text-sm mt-2 text-center">{errors.otp}</p>
                  )}
                  {success.otp && (
                    <p className="text-green-500 text-sm mt-2 text-center">{success.otp}</p>
                  )}
                </div>

                <div className="mb-6 text-center">
                  <p className="text-sm text-[#4A4A4A]/70">
                    {isResendActive ? (
                      <>
                        Didn't receive the code?{" "}
                        <button
                          type="button"
                          className="text-[#951C25] font-medium hover:underline"
                          onClick={handleResendOtp}
                        >
                          Resend
                        </button>
                      </>
                    ) : (
                      <>
                        Resend code in <span className="text-[#951C25] font-medium">{timer}s</span>
                      </>
                    )}
                  </p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#951C25] text-white py-3 rounded-lg font-medium hover:bg-[#951C25]/90 transition-colors flex items-center justify-center"
                  disabled={otp.some((d) => d === "") || isVerifying}
                >
                  {isVerifying ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Verifying...
                    </>
                  ) : (
                    "Verify & Continue"
                  )}
                </button>

                <div className="mt-4 text-center">
                  <Link to="/login" className="text-sm text-[#951C25] hover:underline">
                    Back to Login
                  </Link>
                </div>
              </form>
            </div>
          </div>

          <div className="mt-8 bg-white rounded-lg border border-[#E0E0E0] p-4">
            <div className="flex items-start">
              <div className="mr-3 mt-0.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#951C25"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <div>
                <h3 className="text-sm font-medium text-[#4A4A4A] mb-1">Security Note</h3>
                <p className="text-xs text-[#4A4A4A]/70">
                  Never share your OTP with anyone. Pranaam365 representatives will never ask for your OTP.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-white py-4 border-t border-[#E0E0E0]">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-xs text-[#4A4A4A]/70">© 2025 Pranaam365. All rights reserved.</p>
            <div className="flex space-x-4 mt-2 md:mt-0">
              <Link to="/privacy" className="text-xs text-[#4A4A4A]/70 hover:text-[#951C25]">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-xs text-[#4A4A4A]/70 hover:text-[#951C25]">
                Terms of Service
              </Link>
              <Link to="/help" className="text-xs text-[#4A4A4A]/70 hover:text-[#951C25]">
                Help Center
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
